import { CheckboxGroupButtons, Group } from '@/components/_common';
import CustomersSelectedModal from '@/components/_common/CustomersSelectedModal';
import InsurersSelectedModal from '@/components/_common/InsurersSelectedModal';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  BankSlipBillStatus,
  BankSlipFilterBy,
  BankSlipFilterByConvert,
  BankSlipInvoiceSituation,
  BankSlipInvoiceSituationConvert,
  BankSlipReportFormValues,
} from '@/core/domain/reports/financial/BankSlip/BankSlip.types';
import { useDisclosure } from '@/hooks';
import {
  Badge,
  Button,
  Col,
  Collapse,
  Form,
  FormInstance,
  Radio,
  Row,
  Typography,
} from 'antd';
import { useState } from 'react';

const { Title } = Typography;
const { Panel } = Collapse;

interface Props {
  form: FormInstance<BankSlipReportFormValues>;
}

export default function FinancialBankSlipForm({ form }: Props) {
  const [openCustomer, setOpenCustomer] = useDisclosure(false);
  const [openInsurers, SetOpenInsurers] = useDisclosure(false);

  const [selectedCustomerIds, setSelectedCustomerIds] = useState<number[]>();
  const [selectedInsurersIds, setSelectedInsurersIds] = useState<number[]>();

  const situationOptions = Object.values(BankSlipBillStatus).map((value) => ({
    value,
    label: value.toLowerCase(),
  }));

  const filterByDateByOptions = Object.values(BankSlipFilterBy).map(
    (value) => ({ value, label: BankSlipFilterByConvert[value] }),
  );

  const invoiceSituationOptions = Object.values(BankSlipInvoiceSituation).map(
    (value) => ({ value, label: BankSlipInvoiceSituationConvert[value] }),
  );

  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <>
            <Title level={5} style={{ margin: '0' }}>
              Filtrar por data de
            </Title>

            <Form.Item
              name="filterBy"
              initialValue={BankSlipFilterBy.emission}
              noStyle
            >
              <Radio.Group
                buttonStyle="solid"
                optionType="button"
                options={filterByDateByOptions}
                size="large"
              />
            </Form.Item>
          </>
        }
      />

      <Row style={{ margin: '24px 0' }} gutter={12}>
        <Col span={24}>
          <Form.Item
            name="billStatus"
            label={
              <Title level={5} style={{ margin: '0' }}>
                Situação
              </Title>
            }
            initialValue={[BankSlipBillStatus.issued]}
          >
            <CheckboxGroupButtons
              options={situationOptions}
              style={{ textTransform: 'capitalize' }}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="invoiceSituation"
            label={
              <Title level={5} style={{ margin: '0' }}>
                Situação da Nota Fiscal
              </Title>
            }
            initialValue={[BankSlipInvoiceSituation.authorized]}
          >
            <CheckboxGroupButtons options={invoiceSituationOptions} />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Collapse accordion>
            <Panel header="Mais Opções" key={1}>
              <Row gutter={[24, 24]}>
                <Col span={24} md={12} lg={8} xxl={6}>
                  <Button block type="primary" onClick={setOpenCustomer.open}>
                    <Group gap={10} position="center">
                      Selecionar Clientes
                      <Badge count={selectedCustomerIds?.length} />
                    </Group>
                  </Button>

                  <Form.Item name="customerIds" noStyle>
                    <CustomersSelectedModal
                      visible={openCustomer}
                      handleVisible={setOpenCustomer.close}
                      selectedCustomerIds={selectedCustomerIds}
                      finishCallback={(customer) => {
                        setSelectedCustomerIds(customer);
                        form.setFieldValue('customerIds', customer);
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col span={24} md={12} lg={8} xxl={6}>
                  <Button block type="primary" onClick={SetOpenInsurers.open}>
                    <Group gap={10} position="center">
                      Selecionar Seguradoras
                      <Badge count={selectedInsurersIds?.length} />
                    </Group>
                  </Button>

                  <Form.Item name="insurerIds" noStyle>
                    <InsurersSelectedModal
                      visible={openInsurers}
                      handleVisible={SetOpenInsurers.close}
                      selectedInsurerIds={selectedInsurersIds}
                      finishCallback={(insurers) => {
                        const insurerIds = insurers?.map((value) => value.id);

                        setSelectedInsurersIds(insurerIds);
                        form.setFieldValue('insurerIds', insurerIds);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
        </Col>
      </Row>
    </Form>
  );
}
